export default "__VITE_ASSET__B7dtHR1R__"